<!-- Loading Overlay -->
<app-loading-overlay [show]="isDownloading" message="Downloading PDF..."></app-loading-overlay>

<!-- Start Breadcrumbs -->
<app-breadcrumbs title="Material Acceptances" [breadcrumbItems]="breadCrumbItems"></app-breadcrumbs>
<!-- End Breadcrumbs -->

<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <!-- Header -->
      <div class="card-header border-0">
        <div class="row align-items-center gy-3">
          <div class="col-sm">
            <h5 class="card-title mb-0">Goods Receipt Notes</h5>
          </div>
          <div class="col-sm-auto">
            <div class="d-flex gap-1 flex-wrap">
              <button type="button" class="btn btn-success add-btn" (click)="toggleForm()">
                <i [class]="showForm ? 'ri-close-line' : 'ri-add-line'" class="align-bottom me-1"></i>
                {{ showForm ? 'Cancel' : 'Create Receipt Note' }}
              </button>
              <button type="button" class="btn btn-info" (click)="fetch()">
                <i class="ri-refresh-line align-bottom me-1"></i> Refresh
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Inline Form (Show/Hide) -->
      <div class="card-body border-bottom" *ngIf="showForm" id="materialAcceptanceForm">
        <div class="bg-light p-4 rounded">
          <h5 class="mb-3">
            <i class="ri-file-list-3-line align-middle me-1"></i>
            {{ isEditMode ? 'Edit Material Acceptance' : 'Create Material Acceptance' }}
          </h5>

          <form [formGroup]="form" (ngSubmit)="submit()">
            <div class="row g-3">
              <div class="col-md-3">
                <label class="form-label">Purchase Order <span class="text-danger">*</span></label>
                <ng-select 
                  formControlName="purchase_order_id"
                  [items]="poList"
                  bindLabel="poNumber"
                  bindValue="id"
                  placeholder="Search and select PO..."
                  [searchable]="true"
                  [clearable]="true"
                  [loading]="poLoading"
                  (search)="onPoSearch($event)"
                  [class.is-invalid]="submitted && form.get('purchase_order_id')?.invalid && form.get('purchase_order_id')?.touched">
                </ng-select>
                <div class="invalid-feedback" *ngIf="submitted && form.get('purchase_order_id')?.invalid">Required</div>
              </div>
              <div class="col-md-3">
                <label class="form-label">Received Date <span class="text-danger">*</span></label>
                <input type="date" class="form-control" formControlName="received_date" [class.is-invalid]="submitted && form.get('received_date')?.invalid && form.get('received_date')?.touched">
                <div class="invalid-feedback" *ngIf="submitted && form.get('received_date')?.invalid">Required</div>
              </div>
              <div class="col-md-3">
                <label class="form-label">Invoice Number</label>
                <input type="text" class="form-control" formControlName="invoice_number" placeholder="Enter invoice number">
              </div>
              <div class="col-md-3">
                <label class="form-label">Invoice Date</label>
                <input type="date" class="form-control" formControlName="invoice_date">
              </div>

              <!-- Items Section -->
              <div class="col-lg-12">
                <hr class="my-3">
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <h6 class="mb-0"><i class="ri-shopping-cart-line me-1"></i> Receipt Items</h6>
                </div>

                <div class="table-responsive">
                  <table class="table align-middle table-nowrap">
                    <thead class="table-light">
                      <tr>
                        <th style="width: 50%">Item</th>
                        <th>Ordered</th>
                        <th>Received</th>
                      </tr>
                    </thead>
                    <tbody formArrayName="items">
                      <tr *ngFor="let g of items.controls; let i = index" [formGroupName]="i">
                        <td>{{ poItems[i]?.itemName || ('Item #' + (g.get('item_id')?.value || '')) }} ({{ poItems[i]?.unitSymbol || '-' }})</td>
                        <td><input type="number" class="form-control" formControlName="ordered_quantity" [disabled]="true"></td>
                        <td><input type="number" class="form-control" formControlName="received_quantity"></td>
                      </tr>
                      <tr *ngIf="items.length === 0">
                        <td colspan="3" class="text-center">Select a Purchase Order to load items</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- Form Actions -->
              <div class="col-lg-12">
                <hr class="my-3">
                <div class="d-flex gap-2 justify-content-end">
                  <button type="button" class="btn btn-light" (click)="toggleForm()">
                    <i class="ri-close-line align-bottom me-1"></i> Cancel
                  </button>
                  <button type="submit" class="btn btn-success" [disabled]="loading">
                    <i class="ri-save-line align-bottom me-1"></i>
                    {{ isEditMode ? 'Update' : 'Save' }} Material Acceptance
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <!-- Filters -->
      <div class="card-body border border-dashed border-end-0 border-start-0">
        <div class="row g-3">
          <div class="col-xxl-5 col-sm-6">
            <div class="search-box">
              <input type="text" name="searchTerm" class="form-control" placeholder="Search by GRN, PO, Status..."
                     [(ngModel)]="searchTerm" [ngModelOptions]="{standalone: true}"
                     (keyup.enter)="performSearch()" (blur)="performSearch()">
              <i class="ri-search-line search-icon"></i>
            </div>
          </div>
          <!-- <div class="col-xxl-3 col-sm-4">
            <select class="form-control" name="statusFilter" [(ngModel)]="statusFilter"
                    [ngModelOptions]="{standalone: true}" (ngModelChange)="filterByStatus()">
              <option value="">All Status</option>
              <option value="Accepted">Accepted</option>
              <option value="Partial">Partial</option>
              <option value="Rejected">Rejected</option>
            </select>
          </div> -->
        </div>
      </div>

      <!-- Table -->
      <div class="card-body pt-0">
        <div *ngIf="loading" class="text-center py-5">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>

        <div *ngIf="!loading" class="table-responsive table-card mb-0">
          <table class="table align-middle table-nowrap">
            <thead class="table-light">
              <tr>
                <th>GRN #</th>
                <th>PO #</th>
                <th>Received Date</th>
                <th>Invoice #</th>
                <!-- <th>Status</th> -->
                <th>Received By</th>
                <th>Items</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="visible.length === 0">
                <td colspan="9" class="text-center py-4">
                  <div class="text-muted">
                    <i class="ri-inbox-line fs-1"></i>
                    <p class="mt-2">No material acceptances found</p>
                  </div>
                </td>
              </tr>
              
              <tr *ngFor="let row of visible; let i = index">
                <td><strong>{{ row.grnNumber }}</strong></td>
                <td>{{ row.purchaseOrder?.poNumber }}</td>
                <td>{{ row.receivedDate | date: 'mediumDate' }}</td>
                <td>{{ row.invoiceNumber || '-' }}</td>
                <!-- <td>
                  <span class="badge text-uppercase" [ngClass]="getStatusClass(row.status)">
                    {{ row.status }}
                  </span>
                </td> -->
                <td>{{ row.receivedBy || '-' }}</td>
                <td>
                  <span class="badge bg-primary">{{ row.items?.length || 0 }} items</span>
                </td>
                <td>
                  <div class="d-flex gap-2">
                    <!-- <button class="btn btn-sm btn-info" 
                            (click)="downloadMaterialAcceptance(row.id || row._id)" 
                            [disabled]="isDownloading"
                            ngbTooltip="Download PDF">
                      <i class="ri-download-2-line"></i>
                    </button> -->
                    <!-- <button class="btn btn-sm btn-success" (click)="editMaterialAcceptance(i)" 
                            ngbTooltip="Edit">
                      <i class="ri-pencil-fill"></i>
                    </button> -->
                    <!-- <button class="btn btn-sm btn-danger" (click)="deleteMaterialAcceptance(row.id || row._id)" 
                            ngbTooltip="Delete">
                      <i class="ri-delete-bin-fill"></i>
                    </button> -->
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div class="row justify-content-md-between align-items-md-center mt-3" *ngIf="filtered.length > 0">
          <div class="col col-sm-6">
            <div class="dataTables_info mb-2">
              Showing {{ paginationService.startIndex }} to {{ paginationService.endIndex }} of {{ filtered.length }} entries
            </div>
          </div>
          <div class="col col-sm-6">
            <div class="text-sm-end float-end listjs-pagination">
              <ngb-pagination [collectionSize]="filtered.length"
                              [(page)]="paginationService.page"
                              [pageSize]="paginationService.pageSize"
                              (pageChange)="changePage()">
              </ngb-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
